// Dealing with Sampling Events side of the API
import axios from "axios";
import pako from "pako";
import { getCsrfToken, setupCsrfInterceptor } from "../auth/csrfUtils";

// Create axios instance with default config
const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  // Session cookies are required for this API
  withCredentials: true,
});

// Setup CSRF protection for this API instance
setupCsrfInterceptor(api);

// Sampling Events API endpoints
const baseSamplingEventsUrl = "/sampling_event";

// Get all sampling site names
export const getAllSamplingSites = async () => {
  const response = await api.get(`${baseSamplingEventsUrl}/sampling_sites`);
  return response;
};

// Get sampling site info, can be used to get active only, or all
export const getSamplingSiteInfo = async (siteName, active = true) => {
  const response = await api.get(
    `${baseSamplingEventsUrl}/sampling_site_info?site_name=${siteName}&active=${active}`
  );
  return response;
};

// Save a sampling event
export const saveSamplingEvent = async (samplingEventData) => {
  const response = await api.post(
    `${baseSamplingEventsUrl}/save_sampling_event`,
    samplingEventData
  );
  return response;
};

// Get all active sampling events
export const getAllActiveSamplingEvents = async (page = 1, perPage = 10) => {
  const response = await api.get(
    `${baseSamplingEventsUrl}/active_sampling_events?page=${page}&per_page=${perPage}`
  );
  return response;
};

// Unified list with status filter (active|completed) and pagination
export const getSamplingEvents = async (
  status = "active",
  page = 1,
  perPage = 10
) => {
  const response = await api.get(
    `${baseSamplingEventsUrl}/sampling_events?status=${encodeURIComponent(
      status
    )}&page=${page}&per_page=${perPage}`
  );
  return response;
};

// This is where we will instantiate a new socket connection to the sampling event
export const getSamplingEventById = async (eventId) => {
  const response = await api.get(
    `${baseSamplingEventsUrl}/sampling_event_by_id?event_id=${eventId}`
  );
  return response;
};

// Autosave - patch a sampling event
// This provides a REST fallback for SocketIO autosave for environments without WS support
export const autosaveSamplingEvent = async (samplingEventId, patchData) => {
  const response = await api.patch(
    `${baseSamplingEventsUrl}/${samplingEventId}/autosave`,
    patchData
  );
  return response;
};

// Delete a sampling event
export const deleteSamplingEvent = async (eventId) => {
  const response = await api.post(
    `${baseSamplingEventsUrl}/delete_sampling_event?sampling_event_id=${eventId}`
  );
  return response;
};

// Pull sampling equipment and calibration parameters from the database
export const getSamplingEquipmentMeters = async () => {
  const response = await api.get(
    `${baseSamplingEventsUrl}/sampling_equipment_meters`
  );
  return response;
};
